<div class="card calendar-holder no-border-radius">
  <!-- The duplicated calendar title and the day/week/month switch were
       removed (Ray): the tabs above carry the view switch and the
       breadcrumb's date crumb carries the window. The filters overlay
       stays attached to this template and is toggled from the shared
       controls bar's filters button. -->
  <div [formGroup]="scheduleFilters">
    <p-overlayPanel
      #filtersOverlay
      [style]="{ width: '350px' }"
      appendTo="body"
    >
      <div
        #overlayContent
        class="p-fluid p-formgrid p-grid p-p-2"
        [formGroup]="scheduleFilters"
      >
        <div class="p-field p-col-12">
          <label>Event Types</label>
          <p-multiSelect
            placeholder="Select Event Types"
            formControlName="eventTypes"
            [maxSelectedLabels]="1"
            [options]="systemEventTypes"
            [selectedItemsLabel]="'{0} Event Types'"
            (onChange)="renderAfterDelay()"
            [autofocusFilter]="!responsiveHelper.isSmallScreen"
            data-cy="event-type-multi-select-field"
            appendTo="body"
          ></p-multiSelect>
        </div>
        <div class="p-field p-col-12">
          <label>Asset Types</label>
          <p-multiSelect
            placeholder="Select Asset Types"
            [maxSelectedLabels]="1"
            [selectedItemsLabel]="'{0} Asset Types'"
            [options]="assetTypes"
            formControlName="assetTypes"
            (onChange)="updateAssets(); renderAfterDelay()"
            [autofocusFilter]="!responsiveHelper.isSmallScreen"
            data-cy="asset-types-multi-select-field"
            appendTo="body"
          ></p-multiSelect>
        </div>
      </div>
    </p-overlayPanel>
  </div>

  <!-- The Daily/Month Summary Strip moved into the shared controls bar
       (Ray: the pacing/forecast/availability pieces render LEFT of the
       bar's filter button via ScheduleControlsService.summary — this card
       is now the bare calendar so its borders butt the panel's edges). -->

  <div *ngFor="let remark of visibleDateRemarks" class="remark-container">
    <p-message
      [severity]="remark.severity"
      [text]="remark.date + ': ' + remark.text"
    ></p-message>
  </div>

  <div
    class="timezone-warning-container"
    *ngIf="jobInDifferentTimezoneWarning"
  >
    <p-message
      severity="warn"
      [text]="jobInDifferentTimezoneWarning"
    >
    </p-message>
  </div>

  <p-message
    *ngIf="noAvailableAssetsWarning"
    severity="warn"
    [text]="noAvailableAssetsWarning"
    class="warning"
  ></p-message>

  <div
    class="calendar-holder-inner"
    style="position: relative"
    [class.window-scroll-mode]="dynamicHeight"
    [class.aggregate-view]="!showMonthEvents"
  >
    <full-calendar
      #fc
      [options]="calendarOptions"
    ></full-calendar>
    <!-- Loading is handled BY FullCalendar itself (Ray): placeholder
         "Loading…" resource rows + shimmer event bars are installed on the
         real board on every view switch / boot (installLoadingPlaceholders();
         month aggregate uses per-cell ghost cards). The old separate
         overlay div was retired. -->
  </div>

  <!-- Sticky horizontal scrollbar (ask: "the horizontal scrollbar on the
       week view needs to show when at the top"): FullCalendar's own bar sits
       at the bottom of the (tall) timeline scroller, out of reach while the
       user is anywhere above it. This strip pins to the bottom of .layout-main
       while that native bar is off-screen and mirrors its scrollLeft both
       ways; it collapses once the native bar is visible again. -->
  <!-- starts aria-hidden; the strip itself flips host state imperatively -->
  <app-schedule-sticky-scrollbar
    class="schedule-sticky-scrollbar"
    aria-hidden="true"
  ></app-schedule-sticky-scrollbar>

  <div
    class="card event-edit-bar"
    [ngClass]="{
      'event-edit-bar-safari': responsiveHelper.platform.SAFARI,
      'event-edit-bar-oldios': responsiveHelper.iOSversion <= 14,
    }"
    *ngIf="
      editModeEnabled && !discardEditsDialogVisible && !isMonthView()
    "
  >
    <div class="p-grid">
      <div
        class="p-col-12"
        style="position: relative"
      >
        <div class="centered-checkbox-row">
          <p>
            {{ latestEventEdits.length }} / {{ maximumEditableEvents }} Events
            Edited
          </p>
          <p-checkbox
            [(ngModel)]="notifyAttendees"
            (onChange)="notifyAttendeesChecked($event)"
            binary="true"
            label="Notify Attendees"
          ></p-checkbox>
        </div>
        @if(eventsWithConflictsCount || checkingForConflicts) {
        <h5>
          Conflicts:
          @if (checkingForConflicts) {
          <span>
            Checking for Conflicts ...
            <i class="pi pi-spin pi-spinner"></i>
          </span>
          }
          @else {
          <span class="error-text">
            {{ eventsWithConflictsCount }} conflict(s) found
          </span>
          }
        </h5>
        }
      </div>
      <div class="p-col-12 p-d-flex p-jc-center gap-3">
        <button
          pButton
          label="Discard"
          class="p-button-danger discard-btn"
          icon="pi pi-trash"
          (click)="showDiscardDialog()"
        ></button>
        <div class="button-group">
          <button
            pButton
            label="Undo"
            icon="pi pi-undo"
            [disabled]="!this.eventEdits.length"
            (click)="undoLastEdit()"
            data-cy="undo-button"
          ></button>
          <button
            pButton
            label="Redo"
            icon="pi pi-refresh"
            iconPos="right"
            [disabled]="!this.undoneEventEdits.length"
            (click)="redoEdit()"
            data-cy="redu-button"
          ></button>
        </div>
        <button
          pButton
          label="Save"
          icon="pi pi-save"
          [disabled]="!this.eventEdits.length || this.isSaving"
          (click)="tryToSave()"
        ></button>
      </div>
    </div>
  </div>
</div>
<p-dialog
  [(visible)]="discardEditsDialogVisible"
  [style]="{ width: '50vw' }"
  [breakpoints]="{ '992px': '62vw', '510px': '93vw' }"
  [modal]="true"
>
  <ng-template pTemplate="header">
    <h5>Discard Edits</h5>
  </ng-template>
  <p>Are you sure you want to discard these changes?</p>
  <p-footer>
    <button
      pButton
      label="Cancel"
      class="p-button-text"
      icon="pi pi-times"
      (click)="discardEditsDialogVisible = false"
    ></button>
    <button
      pButton
      label="Discard"
      class="p-button-danger"
      icon="pi pi-save"
      (click)="discardEdits()"
    ></button>
  </p-footer>
</p-dialog>

<p-dialog
  [modal]="true"
  [visible]="isCalendarRemarksDialogOpen$ | async"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '60vw', 'max-width': '900px' }"
  (visibleChange)="$event === false && store.dispatch(DispatchCalendarRemarksDialogActions.dialogClosed())"
>
  <ng-template pTemplate="headless">
    <app-dispatch-calendar-remarks-dialog></app-dispatch-calendar-remarks-dialog>
  </ng-template>
</p-dialog>